import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "32",
      cy: "32",
      r: "31.25",
      stroke: "",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22 32.5L29.5029 38.3356C30.3423 38.9884 31.5457 38.8703 32.2422 38.0667L44 24.5",
      stroke: "",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }